import { useEffect, useState } from "react";
import MediaSection from "../../../components/forms/MediaSection";
import DecorationField from "../../../components/forms/DecorationField";
import { useImageValidation } from "../../../utils/useImageValidation";

import "../../works/api/WorkApi.css";

export default function TeamForm({
  initialData,
  files,
  onImageChange,
  onSubmit,
  submitText,
  loading = false
}) {
  const [formData, setFormData] = useState({
    name: "",
    role: "",
    description: "",
    layout: "left",
    order: 0,
    active: true,
    socials: {
      linkedin: "",
      instagram: "",
      cv: "",
      email: ""
    },
    decorations: [],
  });

  const { registerValidation, hasInvalidImages } = useImageValidation();

  /* ---------- cargar data inicial ---------- */
  useEffect(() => {
    if (!initialData) return;

    setFormData({
      name: initialData.name || "",
      role: initialData.role || "",
      description: initialData.description || "",
      layout: initialData.layout || "left",
      order: initialData.order ?? 0,
      active: initialData.active ?? true,
      socials: {
        linkedin: initialData.socials?.linkedin || "",
        instagram: initialData.socials?.instagram || "",
        cv: initialData.socials?.cv || "",
        email: initialData.socials?.email || ""
      },
      decorations: initialData.decorations || [],
    });
  }, [initialData]);

  function handleChange(e) {
    const { name, value, type, checked } = e.target;

    if (name.startsWith("socials.")) {
      const key = name.split(".")[1];
      setFormData(prev => ({
        ...prev,
        socials: {
          ...prev.socials,
          [key]: value
        }
      }));
      return;
    }

    setFormData(prev => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value
    }));
  }

  function handleSubmit(e) {
    e.preventDefault();
    onSubmit(formData);
  }

  return (
    <div className="work-api-container">
      <form onSubmit={handleSubmit} className="work-form">

        <label>Nombre</label>
        <input
          name="name"
          value={formData.name}
          onChange={handleChange}
          required
        />

        <label>Rol</label>
        <input
          name="role"
          value={formData.role}
          onChange={handleChange}
          required
        />

        <label>Descripción individual</label>
        <textarea
          name="description"
          value={formData.description}
          onChange={handleChange}
          required
        />

        <label>Link completo a perfil de LinkedIn</label>
        <input
          name="socials.linkedin"
          placeholder="https://www.linkedin.com/in/nombre-usuario/"
          value={formData.socials.linkedin}
          onChange={handleChange}
        />

        <label>Link completo a perfil de Instagram</label>
        <input
          name="socials.instagram"
          placeholder="https://www.instagram.com/nombre.usuario/"
          value={formData.socials.instagram}
          onChange={handleChange}
        />

        <label>Mail completo</label>
        <input
          name="socials.email"
          placeholder="nombre@mai.com"
          value={formData.socials.email}
          onChange={handleChange}
        />

        <label>Link completo al alojamiento del CV (PDF)</label>
        <input
          name="socials.cv"
          placeholder="https://drive.google.com/file/d/nombre_del_documento/view?usp=drive_link"
          value={formData.socials.cv}
          onChange={handleChange}
        />
        
        <DecorationField
          value={formData.decorations}
          onChange={decorations =>
            setFormData(prev => ({
              ...prev,
              decorations
            }))
          }
        />

        <MediaSection
          singleImages={[
            {
              key: "image",
              title: "Imagen individual",
              file: files.image?.file ?? null,
              current: files.image?.current ?? initialData?.image,
              onChange: file => onImageChange(file),
              onValidationChange: hasError =>
                registerValidation("image", hasError)
            }
          ]}
        />

        <button disabled={loading || hasInvalidImages} className="form-button">
          {loading ? "Guardando..." : submitText}
        </button>

      </form>
    </div>
  );
}
